var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_2844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 2.5H4.15833C3.23333 2.5 2.50833 3.25 2.50833 4.16667L2.5 15.8333C2.5 16.75 3.23333 17.5 4.15833 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM15.8333 12.5H12.5C12.5 13.8833 11.375 15 10 15C8.625 15 7.5 13.8833 7.5 12.5H4.15833V4.16667H15.8333V12.5ZM6.66667 9.16667H8.33333V11.6667H11.6667V9.16667H13.3333L10 5.83333L6.66667 9.16667Z",
    fill: "#7E0386"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_2844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutbox);
export default __webpack_public_path__ + "static/media/outbox.2f29864e092ba2ff4c96afa388fc157a.svg";
export { ForwardRef as ReactComponent };